import { render, staticRenderFns } from "./park-admin.vue?vue&type=template&id=282cdc30&scoped=true"
import script from "./park-admin.vue?vue&type=script&lang=js"
export * from "./park-admin.vue?vue&type=script&lang=js"
import style0 from "./park-admin.vue?vue&type=style&index=0&id=282cdc30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282cdc30",
  null
  
)

export default component.exports